export interface IDataArray {
  GetById(): number;
}

export class DataArray<T extends IDataArray> {
  public Data: T[];
  public Maps: any[];

  private numberOfMaps: number;

  constructor(numberOfMaps: number = 1) {
    this.numberOfMaps = numberOfMaps;

    this.init();
  }

  public init(): void {
    this.Maps = [];
    this.Data = [];

    for (let i = 0; i < this.numberOfMaps; i++) {
      this.Maps.push([]);
    }
  }

  public unshift(entity: T): void {
    this.Unshift(this, entity);
  }

  public Unshift(self: DataArray<T>, entity: T): void {
    this.Data.unshift(entity);
    for (const entity of this.Data) {
      self.Maps[0][entity.GetById()] = this.Data.indexOf(entity);
    }
  }

  public push(entity: T): void {
    this.Push(this, entity);
  }

  public Push(self: DataArray<T>, entity: T): void {
    const i: number = this.Data.push(entity) - 1;
    this.Maps[0][entity.GetById()] = i;
  }

  public insert(entity: T): boolean {
    return this.Update(this, entity, true);
  }

  public update(entity: T, push: boolean = false, idx: number = -1): boolean {
    return this.Update(this, entity, push, idx);
  }

  public delete(entity: T): boolean {
    return this.Delete(this, entity);
  }

  public Update(
    self: DataArray<T>,
    entity: T,
    push: boolean = true,
    idx: number = -1
  ): boolean {
    if (idx == -1) {
      let i: number = self.Maps[0][entity.GetById()];
      // Added by Bilal
      if (push) {
        i = null;
      } else {
        i = 0;
      }
      // Added by Bilal

      if (i != null) {
        self.Data[i] = entity;

        return true;
      } else {
        if (push) {
          self.Push(this, entity);

          return true;
        }
      }
    } else {
      const i: number = self.Maps[0][entity.GetById()];
      if (push) {
        self.Push(this, entity);
        return true;
      }
      if (i != null) {
        self.Data[i] = entity;
        return true;
      }
    }

    return false;
  }

  public Delete(self: DataArray<T>, entity: T): boolean {
    const idIndex: number = self.Maps[0][entity.GetById()];

    // value already exists
    if (idIndex != null) {
      self.Data.splice(idIndex, 1);
      delete self.Maps[0][entity.GetById()];

      // update the other indexes
      for (const k in self.Maps[0]) {
        if (self.Maps[0][k] > idIndex) {
          self.Maps[0][k] = self.Maps[0][k] - 1;
        }
      }

      return true;
    }

    return false;
  }

  public GetByMap(mapId: number, id: any): T {
    return this.Data[this.Maps[mapId][id]];
  }

  public GetIds(): number[] {
    const ids: number[] = [];

    for (let i = 0; i < this.Data.length; i++) {
      ids.push(this.Data[i].GetById());
    }

    return ids;
  }

  public Clear(): void {
    this.Data = [];
    this.Maps = [];
    for (let i = 0; i < this.numberOfMaps; i++) {
      this.Maps.push([]);
    }
  }
}
